// The organization that owns a product: its logo and name, with a picker.
// The field stores the organization's id, so the document alone cannot say
// which one it is — the editor reads it once and shows it.
import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import DatabaseModelSelectDialog from "aldoo-ra/CMS/dialogs/database-model-select-dialog"
import { orgLogoUrl } from "aldoo-ra/Organizations/api"
import { FolderIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { Thumb } from "aldoo-ra/StoreSales/ui"
import OrganizationAPI from "aldoo-ra/CMSModels/Organization/api"

const idOf = (value) => (value && typeof value === "object" ? value._id : value) || ""

export default function OrganizationField({ value, onChange }) {
  const [organization, setOrganization] = useState(value && typeof value === "object" ? value : null)
  const [selecting, setSelecting] = useState(false)
  const id = idOf(value)

  useEffect(() => {
    if (!id || organization?._id === id) return
    let alive = true
    OrganizationAPI.Get({ match: { _id: id }, page: 1, itemsPerPage: 1 })
      .then((res) => alive && setOrganization(res?.data?.[0] || null))
      .catch(() => alive && setOrganization(null))
    return () => {
      alive = false
    }
  }, [id, organization?._id])

  return (
    <div className="w-full flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <Thumb
          src={organization?.logo ? orgLogoUrl(organization._id, organization.logoUpdatedAt) : null}
          name={organization?.name}
          className="w-10 h-10 rounded-full"
        />
        <Typography variant="admin_body1" className={organization ? "" : "opacity-60"}>
          {organization?.name || (id ? id : "No organization")}
        </Typography>
      </div>

      <div className="flex items-center gap-2">
        <Button variant="admin_secondary" onClick={() => setSelecting(true)}>
          <FolderIcon className="w-4 h-4 mr-1" />
          {id ? "Change" : "Select"}
        </Button>
        {id && (
          <Button
            variant="admin_secondary"
            onClick={() => {
              setOrganization(null)
              onChange?.(null)
            }}
          >
            <XMarkIcon className="w-4 h-4 mr-1" />
            Clear
          </Button>
        )}
      </div>

      {selecting && (
        <DatabaseModelSelectDialog
          type="Organization"
          isOpen={selecting}
          searchFields={["name", "cid"]}
          image={(org) => (org?.logo ? orgLogoUrl(org._id, org.logoUpdatedAt) : null)}
          overview={(org) => org?.cid || ""}
          onClose={() => setSelecting(false)}
          onSelect={(item) => {
            setOrganization(item || null)
            onChange?.(idOf(item))
            setSelecting(false)
          }}
        />
      )}
    </div>
  )
}
